var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgControlIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#061E37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.4,
    height: 7,
    x: 2.65,
    y: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.4,
    height: 9,
    x: 5.3,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.4,
    height: 10,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.4,
    height: 7,
    x: 7.95,
    y: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.4,
    height: 10,
    x: 10.6,
    rx: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlIcon);
export default __webpack_public_path__ + "static/media/control-icon.18421468bf5aaecd0c80b80455462b68.svg";
export { ForwardRef as ReactComponent };